// extracted by mini-css-extract-plugin
export default {"link":"style_link__It5nj","slide-in-bottom":"style_slide-in-bottom__2wuNa"};